var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { styled } from 'linaria/react';
import { usePrice } from '@jetshop/core/hooks/usePrice';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wfsqmst"
});
const NormalPrice = /*#__PURE__*/styled('div')({
  name: "NormalPrice",
  class: "n77d0ua"
});
const OldPrice = /*#__PURE__*/styled('div')({
  name: "OldPrice",
  class: "o1v23gro"
});
const NewPrice = /*#__PURE__*/styled('div')({
  name: "NewPrice",
  class: "nsirej0"
});

const PriceComponent = _a => {
  var _b, _c, _d;

  var {
    className,
    style,
    negative,
    OnHidePriceComponent
  } = _a,
      props = __rest(_a, ["className", "style", "negative", "OnHidePriceComponent"]);

  const {
    hasDiscount,
    formattedPricing,
    hidePrice
  } = usePrice(props);

  if (hidePrice) {
    if (OnHidePriceComponent) {
      return React.createElement(OnHidePriceComponent, Object.assign({}, props));
    } else {
      return null;
    }
  }

  return React.createElement(Wrapper, Object.assign({
    className: className,
    style: style
  }, props, {
    "data-flight-price": ""
  }), hasDiscount ? React.createElement(React.Fragment, null, React.createElement(NewPrice, {
    as: (_b = props === null || props === void 0 ? void 0 : props.as) !== null && _b !== void 0 ? _b : 'div',
    className: "new-price"
  }, formattedPricing.price), React.createElement(OldPrice, {
    as: (_c = props === null || props === void 0 ? void 0 : props.as) !== null && _c !== void 0 ? _c : 'div',
    className: "old-price"
  }, formattedPricing.previousPrice)) : React.createElement(NormalPrice, {
    as: (_d = props === null || props === void 0 ? void 0 : props.as) !== null && _d !== void 0 ? _d : 'div',
    className: "price"
  }, negative && '-', formattedPricing.price));
};

PriceComponent.Wrapper = Wrapper;
PriceComponent.Normal = NormalPrice;
PriceComponent.Old = OldPrice;
PriceComponent.New = NewPrice;
export default PriceComponent;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Price/Price.linaria.css");